// extracted by mini-css-extract-plugin
module.exports = {"helpPageTransitionDelay":"100ms","helpPageTransitionDuration":"270ms"};